import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { formatNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	amount: number;
	meta: string;
};

export const CalculatorResultAmount: FC<Props> = ({ amount, meta }) => {
	const theme = useTheme();

	return (
		<Stack direction="row" alignItems="baseline" gap={theme.spacingTokens.sm}>
			<Typography variant="h1" tabular lineHeight={1} flexShrink={0}>
				{formatNumber(amount)}
			</Typography>
			<Typography
				variant="caption"
				color={theme.palette.grey[600]}
				whiteSpace="nowrap"
			>
				{meta}
			</Typography>
		</Stack>
	);
};
